import styled from "styled-components";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes, mixins } from "@similarweb/styles";

const PopupContent = styled(FlexColumn)`
    width: 320px;
    margin: 16px;
`;
export const DropdownHeader = styled(FlexRow)`
    align-items: center;
    padding-left: 16px;
    padding-top: 8px;
    ${mixins.setFontVariant("subtitle1", colorsPalettes.carbon["400"])};
    height: 40px;
`;

export const RowWrapper = styled(FlexRow)`
    padding: 2px 16px;
    height: 44px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    &:hover {
        background-color: ${colorsPalettes.carbon["25"]};
    }
`;

export const Row = styled(FlexRow)`
    align-items: center;
`;

export const PopupContentText = styled.div`
    ${mixins.setFontVariant("input2", colorsPalettes.carbon["500"])};
    margin-left: 20px;
`;

export const TooltipBody = styled.div`
    ${mixins.setFontVariant("tooltip", colorsPalettes.bluegrey["100"])};
`;
